/* global axios */
import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getTemplates(accountId, inboxId) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/templates`
    );
  }

  createTemplate(accountId, inboxId, templateData) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/templates`,
      { template: templateData }
    );
  }

  deleteTemplate(accountId, inboxId, templateId) {
    return axios.delete(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/templates/${templateId}`
    );
  }

  syncTemplates(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/templates/sync`
    );
  }

  uploadMedia(accountId, inboxId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/inboxes/${inboxId}/whatsapp/templates/upload_media`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
}

export default new WhatsappTemplatesAPI();
